export const operationIdRegex =
  /(?<delimit_start>{{\s*?)operation.(?<uuid>[a-z0-9-]+)(?<delimit_end>\s*?}})/g;
export const collectionIdRegex =
  /(?<delimit_start>{{\s*?)collection.(?<uuid>[a-z0-9-]+)(?<delimit_end>\s*?}})/g;

export const tryParseCustomComponentChild = (
  source: string,
):
  | {
      type: 'saved';
      id: string;
    }
  | {
      type: 'collection';
      id: string;
    }
  | { type: 'none' } => {
  const collectionEntryMatches = [...source.matchAll(operationIdRegex)];
  const collectionEntryIds = collectionEntryMatches.flatMap(
    (collectionEntryMatch) => collectionEntryMatch?.groups?.uuid ?? [],
  );

  const collectionMatches = [...source.matchAll(collectionIdRegex)];
  const collectionIds = collectionMatches.flatMap(
    (collectionEntryMatch) => collectionEntryMatch?.groups?.uuid ?? [],
  );

  if (collectionEntryIds.length === 1 && collectionEntryIds[0]) {
    return {
      id: collectionEntryIds[0],
      type: 'saved',
    };
  } else if (collectionIds.length === 1 && collectionIds[0]) {
    return {
      id: collectionIds[0],
      type: 'collection',
    };
  } else {
    return { type: 'none' };
  }
};
